import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BadgeCheck, MapPin, BookOpen } from "lucide-react";
import api from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export default function Institutes() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => { api.get("/institutes").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <Navbar />
      <div className="border-b border-border bg-card">
        <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
          <h1 className="font-heading text-3xl font-extrabold tracking-tight">Teaching Institutes</h1>
          <p className="mt-2 text-muted-foreground">Verified healthcare teaching institutes on Medlane.</p>
        </div>
      </div>
      <div className="mx-auto grid max-w-7xl gap-6 px-4 py-10 sm:grid-cols-2 sm:px-6 lg:grid-cols-3 lg:px-8">
        {items.map((i) => (
          <button key={i.id} data-testid={`institute-card-${i.id}`}
            onClick={() => nav(`/courses?city=${encodeURIComponent(i.city)}`)}
            className="group overflow-hidden rounded-2xl border border-border bg-card text-left shadow-sm transition-all hover:-translate-y-1 hover:shadow-lg">
            <div className="h-36 overflow-hidden">
              <img src={i.cover_url} alt={i.name} className="h-full w-full object-cover transition-transform group-hover:scale-105" />
            </div>
            <div className="p-5">
              <div className="flex items-start justify-between gap-2">
                <h3 className="font-heading text-lg font-bold">{i.name}</h3>
                {i.verified && <BadgeCheck className="h-5 w-5 shrink-0 text-primary" />}
              </div>
              <p className="mt-1 flex items-center gap-1 text-sm text-muted-foreground"><MapPin className="h-3.5 w-3.5" /> {i.city}, {i.state}</p>
              <p className="mt-3 line-clamp-2 text-sm text-muted-foreground">{i.description}</p>
              <div className="mt-4 flex items-center gap-2 text-xs font-semibold text-primary">
                <BookOpen className="h-4 w-4" /> {i.course_count} course{i.course_count !== 1 ? "s" : ""}
              </div>
            </div>
          </button>
        ))}
      </div>
      <Footer />
    </div>
  );
}
